export default function buildMakePSIGPMReport() {
  return function makePSIGPMReport({
    psi,
    gpm
  }) {
    return Object.freeze({
      get psi() { return psi },
      get gpm() { return gpm },
    });
  }
}